/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { SxProps } from "@mui/material";
import { useSelector } from "react-redux";
import { getUserList } from "../../../../pages/Administrations/helpers";
import { useStoreDispatch } from "../../../../store/hooks";
import { IFilterSelectBox } from "../../../Shared/Filter/types";
import { useUserDisplay } from "../../AccessControls/Users/hooks";
import { setSelectedUserName, setSelectedAuditStatus } from "../../../../store/filters/audit/reducers";
import { auditFilterSelector } from "../../../../store/filters/audit/selectors";

export const useAuditFilter = () => {
  const { selectedUserName, selectedAuditStatus } = useSelector(auditFilterSelector);
  const dispatch = useStoreDispatch();
  const { data } = useUserDisplay();

  const auditFilters: IFilterSelectBox[] = [
    {
      id: "username",
      label: "USER NAME",
      value: selectedUserName || "",
      setValue: setSelectedUserName,
      values: getUserList(data) || [],
      width: "200px",
    },
    {
      id: "auditstatus",
      label: "STATUS",
      value: selectedAuditStatus || "",
      setValue: setSelectedAuditStatus,
      values: [
        { value: "0", text: "Denied" },
        { value: "1", text: "Allowed" },
      ],
      width: "180px",
    },
  ];

  const formControlSx: SxProps = { minWidth: 140, marginRight: "10px" };

  return {
    dispatch,
    auditFilters,
    formControlSx,
  };
};
